export default __webpack_public_path__ + "static/media/depot.c7bb8410.svg";